import React from "react";

/**
 * Presents a real Maintayn product screenshot inside a clean macOS-style browser
 * chrome — large and readable, never a tiny thumbnail. Used across the whole
 * landing page instead of a generic laptop/device mockup.
 */
export function BrowserFrame({ src, alt, className = "", imgClassName = "", height }) {
    return (
        <div
            className={`rounded-xl overflow-hidden border border-brand-forest/10 bg-white shadow-[0_20px_60px_-15px_rgba(31,35,40,0.18)] ${className}`}
            data-testid="browser-frame"
        >
            <div className="h-9 bg-brand-bg flex items-center px-4 border-b border-brand-forest/5 gap-1.5">
                <span className="w-2.5 h-2.5 rounded-full bg-[#D1D5DB]" />
                <span className="w-2.5 h-2.5 rounded-full bg-[#9CA3AF]" />
                <span className="w-2.5 h-2.5 rounded-full bg-[#6B7280]" />
                <span className="ml-3 text-[11px] text-brand-inkSoft/70 truncate">app.maintayn.in</span>
            </div>
            <div className="relative w-full overflow-hidden" style={height ? { height } : undefined}>
                <img
                    src={src}
                    alt={alt}
                    loading="lazy"
                    className={`w-full object-cover object-top border-none ${height ? "h-full" : "h-auto"} ${imgClassName}`}
                />
            </div>
        </div>
    );
}
